module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_MICROFIBER _deskstop.03b29149.jpg";